import { ChangeDetectionStrategy, Component, effect, inject, TemplateRef, viewChild, ViewContainerRef } from '@angular/core';
import { NgpDialogContext, NgpDialogManager } from 'ng-primitives/dialog';

import { OnboardingStatusService } from '../data-access';
import { OnboardingWizard } from './onboarding-wizard';

/**
 * Opens the onboarding wizard modal automatically once for a new member whose account setup is
 * still in progress. Drop this into a page (e.g. the dashboard) without any further wiring.
 */
@Component({
  selector: 'nscp-onboarding-wizard-trigger',
  imports: [OnboardingWizard],
  template: `
    <ng-template #onboardingWizardDialog>
      <nscp-onboarding-wizard />
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingWizardTrigger {
  private readonly onboardingStatusService = inject(OnboardingStatusService);
  private readonly dialogManager = inject(NgpDialogManager);
  private readonly viewContainerRef = inject(ViewContainerRef);

  private readonly onboardingWizardDialogRef = viewChild.required<TemplateRef<NgpDialogContext>>('onboardingWizardDialog');

  private hasAutoOpened = false;

  private readonly onOnboardingInProgress = effect(() => {
    if (this.hasAutoOpened || this.onboardingStatusService.resource.isLoading()) {
      return;
    }

    if (this.onboardingStatusService.isOnboardingInProgress()) {
      this.hasAutoOpened = true;
      this.dialogManager.open(this.onboardingWizardDialogRef(), {
        viewContainerRef: this.viewContainerRef,
        closeOnEscape: false,
      });
    }
  });
}
